import { useRecordContext, useTranslate } from "react-admin";

import { PRACTITIONER_LOCATION_SCOPE } from "../types/practitioner";
import { InfoFieldData, InfoPanel } from "./InfoPanel";
import { PractitionerRecord } from "./PractitionerShow";

export const PractitionerInfoPanel = () => {
  const record = useRecordContext<PractitionerRecord>();
  const translate = useTranslate();

  if (!record) return null;

  const formattedLocations =
    record.locationScope === PRACTITIONER_LOCATION_SCOPE.All
      ? translate("practitionerLocationScope.all")
      : record.locations?.length
        ? record.locations
            .map(loc => (loc.type ? `${loc.name} (${translate(`locationType.${loc.type}`)})` : loc.name))
            .join(", ")
        : translate("noLocations");

  const sections: InfoFieldData[][] = [
    [
      {
        label: translate("salutationLabel"),
        value: record.salutation ? translate(`salutation.${record.salutation.toLowerCase()}`) : undefined,
      },
      { label: translate("firstName"), value: record.firstName },
      { label: translate("lastName"), value: record.lastName },
    ],
    [
      { label: translate("email"), value: record.email },
      { label: translate("telephone"), value: record.telephone },
    ],
    [
      { label: translate("organization"), value: record.organizationName },
      { label: translate("location"), value: formattedLocations },
    ],
    [
      {
        label: translate("status"),
        value: record.status ? translate(`practitionerStatus.${record.status}`) : undefined,
      },
    ],
  ];

  return <InfoPanel sections={sections} />;
};
